<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">组织架构管理</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            <Button @click="addDept" type="primary" class="mRight" v-if="isbutShow.addBut">新增</Button>
            <Button @click="upDateDept" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delDepts">删除</Button>
          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <!-- <Table border :columns="columns" :data="dataTable"
            @on-selection-change="getSelection"
            ></Table>  selectionClick-->
             <tree-grid 
                :items='dataTable' 
                :columns='columns'
                @on-selection-change='selectionClick'
              ></tree-grid>

          </div>

        </div>
      </div>


    </div>

  <!-- 新增admin  / 修改-->
    <Modal
      v-model="addModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <div style="text-align:center">
           <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem label="机构名称" prop="name">
                  <Input v-model="formValidate.name" placeholder="请输入机构名称"></Input>
              </FormItem>
               <FormItem label="上级机构" prop="father">
                  <Button type="default" long style="text-align:left;position:relative;" @click=" modalDept = true "  >{{treeNode}} </Button>
              </FormItem>
               <FormItem label="排序号" prop="order">
                   <InputNumber :min="0" v-model="formValidate.order" placeholder="请输入排序号" style="width:100%;"></InputNumber>
              </FormItem>
               <!-- <FormItem label="业务单元代码" prop="segNo">
                  <Input v-model="formValidate.segNo" placeholder="请输入业务单元代码"></Input>
              </FormItem> -->
              <FormItem label="类型" prop="type">
                  <!-- <Select v-model="formValidate.type"  disabled style="text-align:left;">
                      <Option :value="item.code" v-for="(item,index) in typeList" :key="index">{{item.value}}</Option>
                      <Option value="shanghai">London</Option>
                      <Option value="shenzhen">Sydney</Option>
                  </Select> -->
                  <Input v-model="formValidate.type" disabled></Input>
              </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit('formValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
 <!-- 选择机构 -->
  <Modal
        v-model="modalDept"
        :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>选择机构</span>
        </p>
        <div style="text-align:center">
         <tree-com 
         :deptData="deptLists"
         :addNews = "addNews" 
         :selectedId = "dePtNodeSelect" 
          v-on:getTreeOne = 'getDeptNodes'
          ></tree-com> 
        </div>
        <div slot="footer">
             <Button type="primary" @click="closeDeptModal()" long   >确定</Button>
        </div>
  </Modal>
  
    
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/treeOne' 
  import TreeGrid from '../../components/TreeGrid'
  
  export default{
    data(){
      return {
        addNews:[],
        typeList:[],
       dataTable: [],
       isbutShow:{
        addBut: false,
        delBut: false,
        updateBut: false,
        selectBut: false,
       },
       permissionsLists:[],
        modelName:'新增',
        columns: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '机构ID',
                // type: 'index',
                // sortable: true,
                key:'deptId',
                width: 100,
                align: 'center',

            },
            // {  //添加的expand  
            //     type: 'expand',  
            //     width: 20,  
            //     render: (h, params) => {
            //         return h(expandRow, {  
            //             style:{  
            //                 padding: 0  
            //             },  
            //             props: {  
            //                 row: params.row 
            //             }  
            //         })  
            //     }  
            // }, 
            {
                title: '机构名称', 
                key: 'name',
                align: 'center',
                // render: (h, params) => { 
                //   const row = params.row;
                //   console.log(params)
                //   if(row.open == true){
                //     return h('span', [
                //             h('Icon', {
                //                 props: { 
                //                     type: 'chevron-right', 
                //                 }, 
                //                 style:{  
                //                     marginRight:'8px'  
                //                 } 
                //             }),
                //             h('span', row.name)
                            
                //         ])
                //   }else{
                //     return h('span', row.name)
                //   } 
                // }
            },
            {
                title: '上级机构',
                key: 'parentName',
                align: 'center'
            },
            {
                title: '排序号',
                key: 'orderNum',
                align: 'center'
            }
        ],
        addModel: false,
        updateModel:false,
        modalDept:false,
        resourcesDept:[],
        treeNode:'上级机构',
        treeNodeId:[],
        treeType:'没选择',
        treeSegno:'',
        deptLists:[],
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        selectionRows:[],
        updateId:'',
        dePtNodeSelect:[],
        formValidate: {
            name: '',
            father: '',
            order: 0,
            segNo:'',
            type:''
        },
        ruleValidate: {
            name: [
                { required: true, message: '机构名称不能为空', trigger: 'blur' }
            ],
            // father:[
            //    { required: true, message: '上级机构不能为空',  trigger: 'blur' }
            // ],
            // order: [
            //     { required: true, message: '排序号不能为空', trigger: 'blur' },
            // ],
            segNo: [
                { required: true, message: '业务单元代码不能为空', trigger: 'blur' }
            ],
            type:[
               { required: true, message: '类型不能为空',  trigger: 'blur' }
            ],
        },
        modal_loading: false,

      }
    },
    mounted:function(){  
       // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------
       
        this.getLists();
        this.getDepartment();
        this.getTypeData()
    },
    methods: {
      // 当前表格选中项
      selectionClick(arr) {
            var object = this.deptLists;
           
            this.selectionRows =[];
            // console.log("arr-------"+arr)
            object.forEach(r=>{ 
              if(arr.indexOf(r.deptId) !== -1){
               // console.log(r)
               this.selectionRows.push(r)
              }
             
            })
            // console.log(this.selectionRows)
        },
        getLists(){
            api.Dept.getLists({
            }, resp => {
              console.log(resp)
              this.dataTable = resp.deptList;
            }, error => {

            })
        // 是否具有增删改查按钮权限
        // var menuLeftList = JSON.parse(localStorage.getItem('menuLeftList'));
        // console.log(menuLeftList[0].list)

        

        // // var list = {
        // //   add:false,
        // //   del:true,
        // //   updata:true,
        // //   select:true
        // // }
        // this.isbutShow.addBut = true;
        // this.isbutShow.delBut = true;
        // this.isbutShow.updateBut = true;
        // this.isbutShow.selectBut = true;
        },
        getDepartment:function(){
            api.Dept.treeList({

            }, resp => {
              //console.log(resp)
              this.deptLists = resp.deptList;
              // console.log(this.deptLists)
            }, error => {
              
            })
        },
        getTypeData:function(){
            api.Dept.getType({
              "type":"deptType"
            }, resp => {
              console.log(resp)
              this.typeList = resp.typeList
              //this.deptLists = resp.deptList;
              // console.log(this.deptLists)
            }, error => {
              
            })
        },
        getDeptNodes:function(tree){   // 获得tree选中节点  
            console.log(tree)
            this.treeNodeId = [];//先置空
            if(tree.name){this.treeNode = tree.name;}
            if(tree.title){this.treeNode = tree.title;}
            this.treeNodeId.push(tree.deptId);
            console.log(tree.type)
            this.treeType  = tree.type;
            this.treeSegno = tree.segNo;
        },
        closeDeptModal:function(){
              this.modalDept = false;
              this.formValidate.father = this.treeNode; 
              console.log(this.treeType)
              if(this.treeType == '没选择'){
                this.treeNodeId = [];
                this.formValidate.type ='集团';
                this.treeNodeId.push(0);
                console.log(this.treeNodeId)
              }else{ 
                if(this.treeType == 0){
                  this.formValidate.type ='公司';
                  this.treeNodeId.push(1);
                  console.log('我现在是0');
                }else if(this.treeType == 1){
                  this.formValidate.type ='部门';
                  this.formValidate.segNo = this.treeSegno;
                }else{
                  this.formValidate.type ='部门';
                  this.formValidate.segNo = this.treeSegno;
                }  
            } 
        },

        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                // console.log(valid)
                if (valid) {
                  if(this.formValidate.father == ''){
                    this.$Message.error('请选择上级机构!');
                  }
                  if(this.modelName == "修改"){
                    api.Dept.updateDept({
                      "name": this.formValidate.name,
                      "parentId": this.treeNodeId[0],
                      "orderNum": this.formValidate.order,
                      "segNo": this.formValidate.segNo,
                      "type": this.formValidate.type,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                        this.getLists();
                      }

                    }, error => {

                    })
                  }else if(this.modelName == "新增"){
                   // console.log(this.formValidate.segNo)
                   console.log(this.treeNodeId[0])
                    api.Dept.addDept({
                      "name": this.formValidate.name,
                      "parentId": this.treeNodeId[0],
                      // "parentName":this.treeNode,
                      "orderNum": this.formValidate.order,
                      "segNo": this.formValidate.segNo,
                      "type": this.formValidate.type,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;
                        this.getLists();
                      }
                      

                    }, error => {

                    })
                  }
                  
                    
                } else {
                    this.$Message.error('Fail!');
                }
            })
           

        },
       
        // 删除/批量删除
        delDepts(){
            // this.selectionRows = this.getSelection();
            if(this.selectionRows.length == undefined || this.selectionRows.length != 1){
               this.$Message.error('请选择一条记录!');
                return;
            }
            var deptIds = {};
            // for(var i=0 ;i < this.selectionRows.length; i++){
            //     // console.log(i);
            //     deptIds.push(this.selectionRows[i].deptId);
            // }
            deptIds = {
              deptId:this.selectionRows[0].deptId
            }
            //deptIds = JSON.stringify(deptIds)
            console.log(deptIds)
            // 执行删除
            this.delAdmin(deptIds);
        },
        // 新增 初始化数据
        addDept:function(){
            this.modelName = '新增';
            this.treeNode = "上级机构";
            this.formValidate = {};
            this.addNews= '新增';
           this.addModel = true;
           //this.type ='没选择';
           if( this.treeNode == "上级机构"){
              this.formValidate.type ='集团';
              this.treeNodeId = [];
              this.treeNodeId.push(0);
          }
        },
        // 修改
        upDateDept:function(index){
          this.modelName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }

          this.updateId = this.selectionRows[0].deptId


           var object = this.selectionRows[0];
           // 获取父级节点名字
            this.treeNode =  this.selectionRows[0].parentName;
            // 获取回显父级节点ID
            this.dePtNodeSelect = this.selectionRows[0].parentId;
            // 获取修改后的节点Id
            this.treeNodeId = this.selectionRows[0].parentId;
            // 修改列表数据回显
            // if(this.typeList.length>0){
            //    const  newInfoItems =this.typeList.filter((item) => {
            //     return item.type.toString() === object.type.toString();
            //   });
            // }
            // console.log(newInfoItems)
            this.formValidate ={
                name: this.selectionRows[0].name,
                father:this.selectionRows[0].parentName,
                order:this.selectionRows[0].orderNum,
                segNo:this.selectionRows[0].segNo,
                type: this.selectionRows[0].type,
            }
            // console.log(this.dePtNodeSelect)

          
          this.addNews= '';
          this.addModel = true;
          
        },
        delAdmin:function(deptIds){
           api.Dept.delDept(deptIds
            , resp => {
               console.log(resp)
              // this.resourcesDept = resp.data;
              if(resp.code == 0){
                 this.$Message.success('删除成功!');
                 this.getLists();
              }
              
             
            }, error => {
              
            })
         
        }

    },

      components: {treeCom,TreeGrid}
    }
</script>



// WEBPACK FOOTER //
// organizational.vue?f0ed1310